var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"titles-count"},[_vm._v(_vm._s(_setup.titleCountLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }